import { render, staticRenderFns } from "./score-card-edit.vue?vue&type=template&id=7cbf7dcc"
import script from "./score-card-edit.vue?vue&type=script&lang=js"
export * from "./score-card-edit.vue?vue&type=script&lang=js"
import style0 from "./score-card-edit.vue?vue&type=style&index=0&id=7cbf7dcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports